<template>
  <div v-if="!loginError">
    <h2>Houston... We... *Chrrszzsslbl* *Blip*... Problem...</h2>
    <p>{{ error }}</p>
  </div>
  <div v-else>
    <h2>IT APPEARS THAT YOU'RE CURRENTLY NOT AUTHENTICATED.</h2>
    <p>To continue, please open the popup window and log in.</p>
    <p>Simply click on the button below to open the popup and proceed with the authentication process.</p>
    <p>You might need to accept popups in your browser.</p>

    <el-button
      @click="openLoginTab"
    >
      Open login window
    </el-button>
  </div>
</template>

<style lang="stylus" scoped>
  div
    display flex
    justify-content center
    align-items center
    flex-direction column
    margin-top 20%
  p
    text-align center
</style>

<script>
  import stopsLoading from '../lib/mixins/stopsLoading'

  export default {
    name: 'Failure',
    mixins: [
      stopsLoading
    ],
    props: {
      error: {
        type: Error,
        default: null
      }
    },

    data () {
      return {
        loginError: false
      }
    },

    methods: {
      openLoginTab () {
        window.open(this.error.renewUrl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes')
      }
    },

    mounted () {
      this.loginError = Object.prototype.hasOwnProperty.call(this.error, 'renewUrl')
    }
  }
</script>
